import { useState } from 'react';
import { client } from '../api/Api';

const useReceiptHandler = (
    showSnackbar: (message: string, severity: 'success' | 'error') => void,
    receiptData: any,
    setReceiptData: (data: any) => void,
    setReceiptModalOpen: (open: boolean) => void,
    setNutritionModalOpen: (open: boolean) => void
) => {
    const [newItemName, setNewItemName] = useState('');
    const [newItemPrice, setNewItemPrice] = useState('');
    const [confirming, setConfirming] = useState(false);

    const handleConfirmReceipt = async () => {
        setConfirming(true);
        try {
            // Build payload compatible with ReceiptInfoDTO
            const payload = receiptData ? {
                store_name: receiptData.store_name || receiptData.storeName,
                store_address: receiptData.store_address || receiptData.storeAddress,
                purchase_date: receiptData.purchase_date || receiptData.purchaseDate,
                items: (receiptData.items || []).map((i: any) => ({
                    name: i.name,
                    nameEN: i.nameEN,
                    price: i.price,
                })),
            } : null;

            if (!payload) return;

            // Call confirm endpoint and handle guest flow
            const res = await client.post('/upload/confirm', payload);
            const data = res?.data || {};
            const guestUser = data?.guestUser;

            // Close the receipt modal as we proceed
            setReceiptModalOpen(false);

            if (guestUser) {
                // Not authenticated: store token and redirect to login
                try { localStorage.setItem('guestUploadUser', guestUser); } catch {}
                showSnackbar('Prisijunkite, kad priskirtume įkeltas prekes jūsų paskyrai', 'success');
                window.location.href = '/login';
                return;
            }

            // Authenticated: close modal and show success (receipt saved as message, not processed)
            showSnackbar('Kvitas išsaugotas kaip žinutė. Galite jį apdoroti vėliau.', 'success');
        } catch (e: any) {
            console.error('Confirm failed', e);
            const msg = e?.response?.data?.message || 'Nepavyko išsaugoti kvito';
            showSnackbar(msg, 'error');
        } finally {
            setConfirming(false);
        }
    };

    return {
        confirming,
        setConfirming,
        newItemName,
        setNewItemName,
        newItemPrice,
        setNewItemPrice,
        handleConfirmReceipt,
    };
};

export default useReceiptHandler;